module.exports = __webpack_public_path__ + "static/img/close_p.ed61866.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/close_p.png
// module id = 8Mbj
// module chunks = 66